import React from "react";
import {Row, Col, UncontrolledTooltip} from "reactstrap";
import {IoMdCloseCircleOutline} from "react-icons/io";
import ProtectedContent from "../../../components/protectedContent";
import {MdEdit} from "react-icons/md";

const TemplateListItem = ({
  content,
  id,
  permsForDelete = [],
  onDelete = () => {},
  permsForEdit = [],
  onEdit = () => {},
}) => {
  return (
    <Row style={{margin: "10px 0px"}} className="d-flex align-items-center">
      <Col xs={2} md={1} style={{display: "flex", justifyContent: "end"}}>
        <ProtectedContent perms={permsForDelete}>
          <IoMdCloseCircleOutline
            id={`template-list-delete-button-${id}`}
            onClick={onDelete}
            style={{fontSize: "18px", cursor: "pointer"}}
            data-cy="resultListItemDelete"
          />
          {document.getElementById(`template-list-delete-button-${id}`) && (
            <UncontrolledTooltip
              target={`template-list-delete-button-${id}`}
              placement={"top"}
            >
              Delete
            </UncontrolledTooltip>
          )}
        </ProtectedContent>
      </Col>

      <Col xs={10} md={8}>
        <div
          style={{border: "1px solid #D6D6D6", borderRadius: "4px", padding: "5px 10px"}}
          className="d-flex align-items-baseline"
        >
          <div
            style={{
              flexBasis: "90%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            data-cy="resultListItemContent"
          >
            {content}
          </div>
          <ProtectedContent perms={permsForEdit}>
            <div style={{marginLeft: "auto"}}>
              <span id={`template-list-edit-button-${id}`} style={{cursor: "pointer"}}>
                <MdEdit onClick={onEdit} data-cy="resultListItemEdit" />
              </span>
              {document.getElementById(`template-list-edit-button-${id}`) && (
                <span>
                  <UncontrolledTooltip
                    target={`template-list-edit-button-${id}`}
                    placement={"top"}
                  >
                    Edit
                  </UncontrolledTooltip>
                </span>
              )}
            </div>
          </ProtectedContent>
        </div>
      </Col>
    </Row>
  );
};

export default TemplateListItem;
